import React from 'react';
import WName, {WArticle} from '../WName';
import Eon from '../Eon';
import PL from './ProblemLink';
import AL from '../angles/AngleLink';
import QL from '../faq/QuestionLink';
import NW from '../neologisms/NewWord';
import OML from '../ormaybe/OrMaybeLink';
import LRL from '../longreads/LongReadLink';
import {E1, E2, Qual,
  the_key_is_imagination,
  Rando, SillyName
} from '../common';

// We are literally becominng nazis; Hitler tried to reach power through enforcing conformity
export const nazis = {
  name: "nazis",
  alternatives: "nazi",
  header: <span>
    Humanity-2020, we are literally becoming Nazis.
  </span>,
  outside: <span>
    A ‘nazi’ is not necessarily a ‘bad person’. A ‘nazi’ is just a person <i><PL name="fear">afraid</PL></i> to be <NW>God</NW>. And naziism is all about funnelling and mechanising <QL>life</QL> into <QL name="tm">Life<sup>®</sup></QL>.
  </span>,
  preview: <div className="problem-preview">
    <p>Mechanising <QL>life</QL> into <QL name="tm">Life<sup>®</sup></QL>: the nazi <QL>goal</QL>. That’s not what <WName /> means by ‘<NW word="mechanozoic">mechanozoic</NW>’. But maybe it was exactly what <AL name="notnew.p.">Hannah Arendt</AL> meant by the ‘banality’ of <PL>evil</PL>.</p>
    <p>A nazi does not <NW word="overcome">Ganzesystemüberwinden</NW>. A nazi <i>follows orders</i>.<sup>†</sup></p>
  </div>,
  topFootnote: <div>
    <p>† As an example to illustrate this, <QL name="author.">Pandora</QL> has been completely unable to get a <AL name="handicap">hominid</AL> to <i><QL name="salvation.thinking">engage</QL></i> with the <LRL>nepantla</LRL> proof, just getting <i><PL name="ban">banned</PL></i> from every which site. And now one of the <NW>zyzzyvas</NW> (yes it’s <QL name="author.pandora">her</QL>) had to write the following:</p>
    <pre>{String.raw`import {judaism} from './judaism';`}</pre>
    <p>Thinking about the difference. When you are dealing with <i><PL name="ai">machines</PL></i>, they aren’t <QL name="consciousness">conscious</QL>. Not <NW>POCAs</NW>. So you <i>must</i> format things correctlhy: encase the name of the ‘module’ in curly braces because it’s not a <i>default</i> ‘export’, and <i>don’t forget the semicolon</i>. Because that’s <i>pure <LRL>reactivity</LRL></i>. But <QL>human</QL> <NW>khets</NW>? In short, <WName /> expects (and <i><PL name="uncomfortable">demands</PL></i>) better from a <QL name="body.">super-organ</QL> that <i>could</i> help <LRL name="them">ourself</LRL> – if we <i><AL name="sleeping">wake</AL></i>.</p>
  </div>,
  text: <div className="problem-text">
    <p>Tell ME<sup>™</sup> what to <i>do</i>. I<sup>™</sup> am a <AL>free</AL> Person<sup>™</sup>; I<sup>™</sup> have Agency<sup>™</sup> (predetermined by <LRL name="reactivity">nature</LRL>; Robert Sapolsky told me there’s no FreeWill<sup>®</sup> so I Rightly<sup>®</sup>understand that to mean there’s no <QL>free will</QL>, period).</p>
    <p>Oh, and no; do NOT <PL name="ban">don’t don’t don’t don’t don’t don’t</PL> tell me that I should <i>share</i>. Everyone ELSE is a nazi. Why sould I<sup>™</sup> trust THEM<sup>™</sup>?</p>
    <p><OML name="offensive">I WORKEDD HARDARDARD FOR MY<sup>(™)</sup> MONEYONEYONEYEY!!!!!!!!!!!!111</OML></p>
  </div>,
};
